import { selectCurrentCoursePath } from './Courses/selectors';
import { selectCurrentInstitutionPath } from './Institutions/CurrentInstitutionPath/selectors';

import {
  selectType,
  selectPayload,
  selectQuery,
  selectLocationState,
} from './location/selectors';
import {
  isModuleViewerChange,
  isSameRoute,
  isUserpilotCheckListChange,
} from './location/helpers';
import { currentCohortPathSelector } from './Auth/selectors';

import {
  ROUTE_COURSE_ADMIN,
  ROUTE_COURSE_ASSESSMENT,
  ROUTE_COURSE_CERTIFICATION,
  ROUTE_ACCOUNTS_LOGIN,
  ROUTE_ACCOUNTS_SIGNUP,
  ROUTE_MARKETING_PAGE,
  ROUTE_USER_PROFILE_PAGE,
  ROUTE_USER_PROFILE_PAGE_BLOG,
  ROUTE_WASABI_HOME,
  ROUTE_WASABI_COURSE_LIST,
  ROUTE_WASABI_COURSE_INFO,
  ROUTE_WASABI_INSTITUTION_LIST,
  ROUTE_WASABI_INSTITUTION_INFO,
  ROUTE_WASABI_USER_LIST,
  ROUTE_WASABI_USER_INFO,
  ROUTE_WASABI_EMAIL_TEMPLATES,
  ROUTE_WASABI_SAAS,
  ROUTE_COURSE_PAGE,
  ROUTE_SSO,
  ROUTE_SSR_TEST,
  ROUTE_INSTITUTION_ADMIN,
  ROUTE_COURSES,
  ROUTE_WASABI_PORTFOLIO_INSTITUTIONS,
  ROUTE_WASABI_SAAS_SUBSCRIPTION_INFO,
  ROUTE_WASABI_FEATURED_INSTITUTIONS,
  ROUTE_PARTNERS_LISTING_PAGE,
  ROUTE_HOMEPAGE,
  ROUTE_ACCOUNTS_SUBSCRIPTIONS,
} from './routeActions';
import { WasabiPages } from '../web/containers/WasabiPage/constants';

export const COURSE_ADMIN_ACTIONS_IN_SPA = [
  'exports',
  'roles',
  'outcomes',
  'landing_page',
  'content',
];

export const COURSE_ADMIN_QUERY_ACTION_IN_SPA = ['general'];

export const INSTITUTION_ADMIN_ACTIONS_WITH_SPA = [
  'ltiIntegrations',
  'courses',
  'studentData',
];

export const shouldReload = (getState, action) => {
  const locationType = selectType(getState());
  const locationPayload = selectPayload(getState());
  const locationQuery = selectQuery(getState());
  const { query } = action;

  // (Unfortunately), by default, reload the page on all transitions
  let reload = true;

  let queryCohort = null;
  if (query.cohort) {
    queryCohort = query.cohort.toLowerCase();
  }

  switch (action.type) {
    case ROUTE_MARKETING_PAGE: {
      reload = locationType !== ROUTE_MARKETING_PAGE; // Praise the lord
      break;
    }
    case ROUTE_HOMEPAGE:
    case ROUTE_PARTNERS_LISTING_PAGE:
    case ROUTE_COURSES: {
      switch (locationType) {
        case ROUTE_HOMEPAGE:
        case ROUTE_PARTNERS_LISTING_PAGE:
        case ROUTE_COURSES: {
          reload = false;
          break;
        }
        default: {
          break;
        }
      }
      break;
    }
    case ROUTE_USER_PROFILE_PAGE_BLOG: {
      reload = true;
      break;
    }
    case ROUTE_USER_PROFILE_PAGE: {
      // Reload if we aren't coming from the ROUTER_USER_PROFILE_PAGE type
      // this prevents the back button from behaving weirdly when navigating
      // to the ROUTER_USER_PROFILE_PAGE_BLOG and back
      if (locationType === ROUTE_USER_PROFILE_PAGE) {
        reload = false; // Praise the lord
      }
      break;
    }
    case ROUTE_COURSE_PAGE: {
      if (
        locationType === action.type &&
        action.state.legacySPA &&
        action.location.kind === 'push'
      ) {
        reload = false;
      }
      break;
    }
    case ROUTE_COURSE_ADMIN: {
      if (
        (locationType === ROUTE_COURSE_ADMIN ||
          locationType === ROUTE_COURSE_CERTIFICATION ||
          locationType === ROUTE_COURSE_ASSESSMENT) &&
        COURSE_ADMIN_ACTIONS_IN_SPA.indexOf(query.action) !== -1 &&
        selectCurrentCoursePath(getState()) === query.course.toLowerCase() &&
        currentCohortPathSelector(getState()) === queryCohort
      ) {
        reload = false;
      } else if (
        locationType === ROUTE_COURSE_ADMIN &&
        COURSE_ADMIN_QUERY_ACTION_IN_SPA.indexOf(query.action) !== -1 &&
        locationQuery.get('action') === query.action &&
        selectCurrentCoursePath(getState()) === query.course.toLowerCase() &&
        currentCohortPathSelector(getState()) === queryCohort
      ) {
        reload = false;
      }
      break;
    }
    case ROUTE_COURSE_ASSESSMENT: {
      if (
        locationType === ROUTE_COURSE_ASSESSMENT &&
        selectCurrentCoursePath(getState()) === query.course.toLowerCase() &&
        currentCohortPathSelector(getState()) === queryCohort
      ) {
        reload = false;
      }
      break;
    }
    case ROUTE_COURSE_CERTIFICATION: {
      if (
        locationType === ROUTE_COURSE_CERTIFICATION &&
        selectCurrentCoursePath(getState()) === query.course.toLowerCase() &&
        currentCohortPathSelector(getState()) === queryCohort &&
        action.params.action === 'students' &&
        locationPayload.get('action') === 'students'
      ) {
        reload = false;
      }
      break;
    }
    case ROUTE_SSR_TEST:
    case ROUTE_SSO:
    case ROUTE_ACCOUNTS_LOGIN:
    case ROUTE_ACCOUNTS_SUBSCRIPTIONS:
    case ROUTE_ACCOUNTS_SIGNUP: {
      reload = locationType !== action.type;
      break;
    }
    case ROUTE_WASABI_HOME:
    case ROUTE_WASABI_COURSE_LIST:
    case ROUTE_WASABI_COURSE_INFO:
    case ROUTE_WASABI_INSTITUTION_LIST:
    case ROUTE_WASABI_INSTITUTION_INFO:
    case ROUTE_WASABI_USER_LIST:
    case ROUTE_WASABI_USER_INFO:
    case ROUTE_WASABI_SAAS:
    case ROUTE_WASABI_SAAS_SUBSCRIPTION_INFO:
    case ROUTE_WASABI_EMAIL_TEMPLATES:
    case ROUTE_WASABI_FEATURED_INSTITUTIONS:
    case ROUTE_WASABI_PORTFOLIO_INSTITUTIONS: {
      const isWithinAdmin =
        WasabiPages.includes(locationType) && WasabiPages.includes(action.type);
      reload = !isWithinAdmin;
      break;
    }
    case ROUTE_INSTITUTION_ADMIN: {
      if (
        locationType === ROUTE_INSTITUTION_ADMIN &&
        INSTITUTION_ADMIN_ACTIONS_WITH_SPA.indexOf(query.action) !== -1 &&
        locationQuery.get('action') === query.action &&
        selectCurrentInstitutionPath(getState()) ===
          query.institution.toLowerCase()
      ) {
        /**
         * Allow changes to query parameters within particular pages
         * (`action` query parameter) of institution admin (not between
         * different pages / values of `action`).
         */
        reload = false;
      }
      break;
    }
    default: {
      break;
    }
  }

  // Seperate checklist for course UI transitions
  if (isModuleViewerChange(selectLocationState(getState()), action)) {
    reload = false;
  }

  if (isUserpilotCheckListChange(selectLocationState(getState()), action)) {
    reload = false;
  }

  if (isSameRoute(selectLocationState(getState()), action)) {
    // Redirecting to literally the same route does not cause a page reload
    reload = false;
  }
  return reload;
};
